<div class="container-md h-100 d-flex flex-column pb-md-1">
    <main class="flex-grow-1 main-content p-3 bg-acbg d-flex flex-column" style="min-height: 0; overflow: hidden">
      <app-header class="flex-shrink-0"></app-header>
      <div class="flex-grow-1" style="min-height: 0">
        <router-outlet></router-outlet>
      </div>
      <app-footer class="d-none d-md-block flex-shrink-0 pt-1"></app-footer>
    </main>
  </div>
  